import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const CircleImageContent = props => {
  switch (props.svgImage) {
    case 'one':
      return /*#__PURE__*/_jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 40 40",
        children: [/*#__PURE__*/_jsx("defs", {
          children: /*#__PURE__*/_jsx("clipPath", {
            id: "clip-path",
            children: /*#__PURE__*/_jsx("rect", {
              id: "Rectangle_1593",
              "data-name": "Rectangle 1593",
              width: "40",
              height: "40",
              rx: "20",
              transform: "translate(0 -0.085)",
              fill: ""
            })
          })
        }), /*#__PURE__*/_jsx("g", {
          id: "Group_18462",
          "data-name": "Group 18462",
          transform: "translate(21033 -8102)",
          children: /*#__PURE__*/_jsxs("g", {
            id: "Group_18458",
            "data-name": "Group 18458",
            transform: "translate(-21033 7974.338)",
            children: [/*#__PURE__*/_jsx("rect", {
              id: "Rectangle_730",
              "data-name": "Rectangle 730",
              width: "40",
              height: "40",
              rx: "20",
              transform: "translate(0 127.662)",
              fill: "#8bbfc6"
            }), /*#__PURE__*/_jsxs("g", {
              id: "Mask_Group_83",
              "data-name": "Mask Group 83",
              transform: "translate(0 127.748)",
              clipPath: "url(#clip-path)",
              children: [/*#__PURE__*/_jsxs("g", {
                id: "Group_18401",
                "data-name": "Group 18401",
                transform: "translate(-69.22 8.582)",
                children: [/*#__PURE__*/_jsx("path", {
                  id: "Path_40513",
                  "data-name": "Path 40513",
                  d: "M126,539c4.21,0,4.21,3.877,8.42,3.877S138.63,539,142.84,539s4.209,3.877,8.42,3.877S155.47,539,159.68,539s4.21,3.877,8.421,3.877,4.21-3.877,8.421-3.877,4.21,3.877,8.42,3.877,4.21-3.877,8.421-3.877,4.21,3.877,8.421,3.877S205.993,539,210.2,539s4.21,3.877,8.421,3.877",
                  transform: "translate(-126 -539)",
                  fill: "rgba(255,255,255,0)",
                  stroke: "#acdae0",
                  strokeWidth: "2"
                }), /*#__PURE__*/_jsx("path", {
                  id: "Path_40514",
                  "data-name": "Path 40514",
                  d: "M126,539c4.21,0,4.21,3.877,8.42,3.877S138.63,539,142.84,539s4.209,3.877,8.42,3.877S155.47,539,159.68,539s4.21,3.877,8.421,3.877,4.21-3.877,8.421-3.877,4.21,3.877,8.42,3.877,4.21-3.877,8.421-3.877,4.21,3.877,8.421,3.877S205.993,539,210.2,539s4.21,3.877,8.421,3.877",
                  transform: "translate(-126 -534.767)",
                  fill: "rgba(255,255,255,0)",
                  stroke: "#acdae0",
                  strokeWidth: "2"
                })]
              }), /*#__PURE__*/_jsx("ellipse", {
                id: "Ellipse_252",
                "data-name": "Ellipse 252",
                cx: "9.5",
                cy: "10",
                rx: "9.5",
                ry: "10",
                transform: "translate(10 32.915)",
                fill: "rgba(255,255,255,0)",
                stroke: "#acdae0",
                strokeWidth: "2"
              })]
            })]
          })
        })]
      });

    case 'two':
      return /*#__PURE__*/_jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 40 40",
        children: [/*#__PURE__*/_jsxs("defs", {
          children: [/*#__PURE__*/_jsx("clipPath", {
            id: "clip-path",
            children: /*#__PURE__*/_jsx("rect", {
              id: "Rectangle_1287",
              "data-name": "Rectangle 1287",
              width: "40",
              height: "40",
              rx: "20",
              transform: "translate(0 -0.212)",
              fill: ""
            })
          }), ' ']
        }), /*#__PURE__*/_jsx("g", {
          id: "Group_18461",
          "data-name": "Group 18461",
          transform: "translate(21033 -8038)",
          children: /*#__PURE__*/_jsxs("g", {
            id: "Group_18459",
            "data-name": "Group 18459",
            transform: "translate(-21033 7974.338)",
            children: [/*#__PURE__*/_jsx("rect", {
              id: "Rectangle_727",
              "data-name": "Rectangle 727",
              width: "40",
              height: "40",
              rx: "20",
              transform: "translate(0 63.662)",
              fill: "#7295c4"
            }), /*#__PURE__*/_jsxs("g", {
              id: "Mask_Group_4",
              "data-name": "Mask Group 4",
              transform: "translate(0 63.874)",
              clipPath: "url(#clip-path)",
              children: [/*#__PURE__*/_jsxs("g", {
                id: "Group_18163",
                "data-name": "Group 18163",
                transform: "translate(-25.639 24.933)",
                children: [/*#__PURE__*/_jsx("path", {
                  id: "Path_40507",
                  "data-name": "Path 40507",
                  d: "M126,539c4.21,0,4.21,3.877,8.42,3.877S138.63,539,142.84,539s4.209,3.877,8.42,3.877S155.47,539,159.68,539s4.21,3.877,8.421,3.877,4.21-3.877,8.421-3.877,4.21,3.877,8.42,3.877,4.21-3.877,8.421-3.877,4.21,3.877,8.421,3.877S205.993,539,210.2,539s4.21,3.877,8.421,3.877",
                  transform: "translate(-126 -539)",
                  fill: "rgba(255,255,255,0)",
                  stroke: "#8fb2e2",
                  strokeWidth: "2"
                }), /*#__PURE__*/_jsx("path", {
                  id: "Path_40508",
                  "data-name": "Path 40508",
                  d: "M126,539c4.21,0,4.21,3.877,8.42,3.877S138.63,539,142.84,539s4.209,3.877,8.42,3.877S155.47,539,159.68,539s4.21,3.877,8.421,3.877,4.21-3.877,8.421-3.877,4.21,3.877,8.42,3.877,4.21-3.877,8.421-3.877,4.21,3.877,8.421,3.877S205.993,539,210.2,539s4.21,3.877,8.421,3.877",
                  transform: "translate(-126 -534.767)",
                  fill: "rgba(255,255,255,0)",
                  stroke: "#8fb2e2",
                  strokeWidth: "2"
                })]
              }), /*#__PURE__*/_jsx("circle", {
                id: "Ellipse_120",
                "data-name": "Ellipse 120",
                cx: "10",
                cy: "10",
                r: "10",
                transform: "translate(26 -8.212)",
                fill: "rgba(255,255,255,0)",
                stroke: "#8fb2e2",
                strokeWidth: "2"
              })]
            })]
          })
        })]
      });

    case 'three':
      return /*#__PURE__*/_jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 40 40",
        children: [/*#__PURE__*/_jsx("defs", {
          children: /*#__PURE__*/_jsx("clipPath", {
            id: "clip-path",
            children: /*#__PURE__*/_jsx("rect", {
              id: "Rectangle_1285",
              "data-name": "Rectangle 1285",
              width: "40",
              height: "40",
              rx: "20",
              transform: "translate(0 -0.338)",
              fill: ""
            })
          })
        }), /*#__PURE__*/_jsxs("g", {
          id: "Group_18460",
          "data-name": "Group 18460",
          transform: "translate(21033 -7974)",
          children: [/*#__PURE__*/_jsx("rect", {
            id: "Rectangle_173",
            "data-name": "Rectangle 173",
            width: "40",
            height: "40",
            rx: "20",
            transform: "translate(-21033 7974)",
            fill: "#6877c6"
          }), /*#__PURE__*/_jsxs("g", {
            id: "Mask_Group_2",
            "data-name": "Mask Group 2",
            transform: "translate(-21033 7974.338)",
            clipPath: "url(#clip-path)",
            children: [/*#__PURE__*/_jsxs("g", {
              id: "Group_18161",
              "data-name": "Group 18161",
              transform: "translate(8.258 7.084)",
              children: [/*#__PURE__*/_jsx("path", {
                id: "Path_40503",
                "data-name": "Path 40503",
                d: "M126,539c4.21,0,4.21,3.877,8.42,3.877S138.63,539,142.84,539s4.209,3.877,8.42,3.877S155.47,539,159.68,539s4.21,3.877,8.421,3.877,4.21-3.877,8.421-3.877,4.21,3.877,8.42,3.877,4.21-3.877,8.421-3.877,4.21,3.877,8.421,3.877S205.993,539,210.2,539s4.21,3.877,8.421,3.877",
                transform: "translate(-126 -539)",
                fill: "rgba(255,255,255,0)",
                stroke: "#7887d9",
                strokeWidth: "2"
              }), /*#__PURE__*/_jsx("path", {
                id: "Path_40504",
                "data-name": "Path 40504",
                d: "M126,539c4.21,0,4.21,3.877,8.42,3.877S138.63,539,142.84,539s4.209,3.877,8.42,3.877S155.47,539,159.68,539s4.21,3.877,8.421,3.877,4.21-3.877,8.421-3.877,4.21,3.877,8.42,3.877,4.21-3.877,8.421-3.877,4.21,3.877,8.421,3.877S205.993,539,210.2,539s4.21,3.877,8.421,3.877",
                transform: "translate(-126 -534.767)",
                fill: "rgba(255,255,255,0)",
                stroke: "#7887d9",
                strokeWidth: "2"
              }), /*#__PURE__*/_jsx("circle", {
                id: "Ellipse_118",
                "data-name": "Ellipse 118",
                cx: "10",
                cy: "10",
                r: "10",
                transform: "translate(-4 26.662)",
                fill: "rgba(255,255,255,0)",
                stroke: "#7887d9",
                strokeWidth: "2"
              })]
            }), "<"]
          })]
        })]
      });

    default:
      return /*#__PURE__*/_jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 40 40",
        children: [/*#__PURE__*/_jsx("defs", {
          children: /*#__PURE__*/_jsx("clipPath", {
            id: "clip-path",
            children: /*#__PURE__*/_jsx("rect", {
              id: "Rectangle_1593",
              "data-name": "Rectangle 1593",
              width: "40",
              height: "40",
              rx: "20",
              transform: "translate(0 -0.085)",
              fill: ""
            })
          })
        }), /*#__PURE__*/_jsx("g", {
          id: "Group_18462",
          "data-name": "Group 18462",
          transform: "translate(21033 -8102)",
          children: /*#__PURE__*/_jsxs("g", {
            id: "Group_18458",
            "data-name": "Group 18458",
            transform: "translate(-21033 7974.338)",
            children: [/*#__PURE__*/_jsx("rect", {
              id: "Rectangle_730",
              "data-name": "Rectangle 730",
              width: "40",
              height: "40",
              rx: "20",
              transform: "translate(0 127.662)",
              fill: "#8bbfc6"
            }), /*#__PURE__*/_jsxs("g", {
              id: "Mask_Group_83",
              "data-name": "Mask Group 83",
              transform: "translate(0 127.748)",
              clipPath: "url(#clip-path)",
              children: [/*#__PURE__*/_jsxs("g", {
                id: "Group_18401",
                "data-name": "Group 18401",
                transform: "translate(-69.22 8.582)",
                children: [/*#__PURE__*/_jsx("path", {
                  id: "Path_40513",
                  "data-name": "Path 40513",
                  d: "M126,539c4.21,0,4.21,3.877,8.42,3.877S138.63,539,142.84,539s4.209,3.877,8.42,3.877S155.47,539,159.68,539s4.21,3.877,8.421,3.877,4.21-3.877,8.421-3.877,4.21,3.877,8.42,3.877,4.21-3.877,8.421-3.877,4.21,3.877,8.421,3.877S205.993,539,210.2,539s4.21,3.877,8.421,3.877",
                  transform: "translate(-126 -539)",
                  fill: "rgba(255,255,255,0)",
                  stroke: "#acdae0",
                  strokeWidth: "2"
                }), /*#__PURE__*/_jsx("path", {
                  id: "Path_40514",
                  "data-name": "Path 40514",
                  d: "M126,539c4.21,0,4.21,3.877,8.42,3.877S138.63,539,142.84,539s4.209,3.877,8.42,3.877S155.47,539,159.68,539s4.21,3.877,8.421,3.877,4.21-3.877,8.421-3.877,4.21,3.877,8.42,3.877,4.21-3.877,8.421-3.877,4.21,3.877,8.421,3.877S205.993,539,210.2,539s4.21,3.877,8.421,3.877",
                  transform: "translate(-126 -534.767)",
                  fill: "rgba(255,255,255,0)",
                  stroke: "#acdae0",
                  strokeWidth: "2"
                })]
              }), /*#__PURE__*/_jsx("ellipse", {
                id: "Ellipse_252",
                "data-name": "Ellipse 252",
                cx: "9.5",
                cy: "10",
                rx: "9.5",
                ry: "10",
                transform: "translate(10 32.915)",
                fill: "rgba(255,255,255,0)",
                stroke: "#acdae0",
                strokeWidth: "2"
              })]
            })]
          })
        })]
      });
  }
};

export default CircleImageContent;